import axios from "../axiosPlugin.js";

// memberShipList
export const getMemberShipListService = data => {
  return axios({
    url: "/api/cl/membership/list",
    method: "get",
    data: {
      data,
    },
  });
};

export const getCouponListMapService = data => {
  return axios({
    url: "/api/cl/coupon/options-list",
    method: "get",
    data: {
      data,
    },
  });
};

export const createMemberShipService = data => {
  return axios({
    url: "/api/cl/membership/create",
    method: "post",
    data: {
      data,
    },
  });
};

export const getMemberShipDetailService = data => {
  return axios({
    url: `/api/cl/membership/detail/${data.id}`,
    method: "get",
    data: {},
  });
};

export const updateMemberShipService = data => {
  return axios({
    url: "/api/cl/membership/update",
    method: "post",
    data: {
      data,
    },
  });
};

export const removeMemberShipService = data => {
  return axios({
    url: `/api/cl/membership/delete/${data.id}`,
    method: "get",
    data: {},
  });
};

export const getMemberShipOptionListService = data => {
  return axios({
    url: "/api/cl/membership/options-list",
    method: "get",
    data: {
      data
    },
  });
};

// memberAgeGroup（年龄区分）
export const getMemberAgeGroupListService = data => {
  return axios({
    url: "/api/cl/memberAgeGroup/list",
    method: "get",
    data: {
      data,
    },
  });
};

export const getMemberAgeGroupDetailService = id => {
  return axios({
    url: `/api/cl/memberAgeGroup/detail/${id}`,
    method: "get",
    data: {},
  });
};

export const createMemberAgeGroupService = data => {
  return axios({
    url: "/api/cl/memberAgeGroup/create",
    method: "post",
    data: {
      data,
    },
  });
};

export const updateMemberAgeGroupService = data => {
  return axios({
    url: "/api/cl/memberAgeGroup/update",
    method: "post",
    data: {
      data,
    },
  });
};

export const deleteMemberAgeGroupService = id => {
  return axios({
    url: `/api/cl/memberAgeGroup/delete/${id}`,
    method: "get",
    data: {},
  });
};

// 「切替特典を補発」暂时不做，确认要做时再恢复
// // 切替特典的手动补发：只补发指定会员制度下的指定区间。brandId 和操作人由服务端从登录账号获取
// export const grantAgeGroupChangeWelfareService = ({ days, memberShipId, ageGroupId }) => {
//   return axios({
//     url: `/api/cl/memberAgeGroup/change-welfare?days=${days}&memberShipId=${memberShipId}&ageGroupId=${ageGroupId}`,
//     method: "post",
//     data: {},
//   });
// };

// memberList
export const getMemberListService = data => {
  return axios({
    url: "/api/cl/member/list",
    method: "get",
    data: {
      data
    },
  });
};

export const getMemberDetailService = data => {
  return axios({
    url: "/api/cl/member/detail",
    method: "get",
    data: {
      data
    },
  });
};
// 利用停止
export const updateMemberStatusService = data => {
  return axios({
    url: `/api/cl/member/update-member-status?userId=${data.id}`,
    method: "put",
    data: {},
  });
};

// 退会 (MemberStatus.delete) - terminology per human.answer-1
export const deleteMemberService = data => {
  return axios({
    url: `/api/cl/member/delete-member?userId=${data.id}`,
    method: "delete",
    data: {},
  });
};

// 会員種類変更
export const updateMemberShipTypeService = data => {
  return axios({
    url: `/api/cl/member/update-member-memberShip?userId=${data.userId}&memberShipId=${data.memberShipId}&expireTime=${!data.expireTime ? "" : data.expireTime}&expireTimeLimit=${data.expireTimeLimit}&remark=${data.remark}`,
    method: "put",
    data: {},
  });
};

// ランク変更
export const updateMemberShipRankService = data => {
  return axios({
    url: `/api/cl/member/update-member-memberShipRank?userId=${data.userId}&memberShipRankId=${data.memberShipRankId}&remark=${data.remark}`,
    method: "put",
    data: {},
  });
};
// 解約
export const memberQuitService = data => {
  return axios({
    url: `/api/cl/member/member-quit?userId=${data.userId}`,
    method: "put",
    data: {},
  });
};

export const updateUserInfoService = data => {
  return axios({
    url: `/api/cl/member/update-userInfo/${data.userId}`,
    method: "post",
    data: {
      data: data.userInfo
    }
  });
};

// log
export const getMemberCouponLogService = data => {
  return axios({
    url: "/api/cl/memberCoupon/list",
    method: "get",
    data: {
      data
    }
  });
};

export const sendCouponService = data => {
  let str = `?couponId=${data.couponId}` + (data.expireTime ? `&expireTime=${data.expireTime}` : "") + `&remark=${data.remark}&userId=${data.userId}`;
  return axios({
    url: `/api/cl/memberCoupon/sendCoupon${str}`,
    method: "post",
    data: {
      data
    }
  });
};

export const updateMemberCouponStatusService = data => {
  return axios({
    url: `/api/cl/memberCoupon/update-status?memberCouponId=${data.couponId}&status=${data.status}`,
    method: "put",
    data: {
      data
    }
  });
};

export const getCouponUseLogService = data => {
  return axios({
    url: "/api/cl/couponUseLog/list",
    method: "get",
    data: {
      data
    }
  });
};

export const getPointLogService = data => {
  return axios({
    url: "/api/cl/memberPointLog/list",
    method: "get",
    data: {
      data
    }
  });
};

export const adjustPointService = data => {
  return axios({
    url: `/api/cl/member/adjust-point?userId=${data.userId}&point=${data.point}&remark=${data.remark}`,
    method: "put",
    data: {}
  });
};

export const getRankLogService = data => {
  return axios({
    url: "/api/cl/memberRankLog/list",
    method: "get",
    data: {
      data
    }
  });
};

export const getMemberShipChangeLogService = data => {
  return axios({
    url: "/api/cl/membershipLog/list",
    method: "get",
    data: {
      data
    }
  });
};

// couponList
export const getCouponOptionListService = data => {
  return axios({
    url: "/api/cl/coupon/listMap",
    method: "get",
    data: {
      data,
    },
  });
};

export const getCouponListService = data => {
  return axios({
    url: "/api/cl/coupon/list",
    method: "get",
    data: {
      data,
    },
  });
};

export const getCouponListDetailService = id => {
  return axios({
    url: `/api/cl/coupon/detail/${id}`,
    method: "get",
    data: {},
  });
};

export const createCouponService = data => {
  return axios({
    url: "/api/cl/coupon/create",
    method: "post",
    data: {
      data
    },
  });
};

export const deleteCouponService = id => {
  return axios({
    url: `/api/cl/coupon/delete/${id}`,
    method: "get",
    data: {},
  });
};

export const updateCouponService = data => {
  return axios({
    url: "/api/cl/coupon/update",
    method: "post",
    data: {
      data
    },
  });
};

export const getEndUserCustomizeService = data => {
  return axios({
    url: "/api/cl/endUserCustomize/current",
    method: "get",
    data: {
      data
    },
  });
};

export const updateEndUserCustomizeService = data => {
  return axios({
    url: "/api/cl/endUserCustomize/update",
    method: "put",
    data: {
      data
    },
  });
};

export const getAutoJobListService = data => {
  return axios({
    url: "/api/cl/autoJob/list",
    method: "get",
    data: {
      data
    },
  });
};

export const createAutoJobService = data => {
  return axios({
    url: "/api/cl/autoJob/create",
    method: "post",
    data: {
      data
    },
  });
};

export const deleteAutoJobService = id => {
  return axios({
    url: `/api/cl/autoJob/delete/${id}`,
    method: "delete",
    data: {},
  });
};

export const getAutoJobDetailService = id => {
  return axios({
    url: `/api/cl/autoJob/detail/${id}`,
    method: "get",
    data: {},
  });
};

export const updateAutoJobStatusService = id => {
  return axios({
    url: `/api/cl/autoJob/update-status?id=${id}`,
    method: "put",
    data: {},
  });
};
export const updateAutoJobService = data => {
  return axios({
    url: "/api/cl/autoJob/update",
    method: "put",
    data: {
      data,
    },
  });
};

export const getRankOptionService = data => {
  return axios({
    url: "/api/cl/memberRankLog/rank-option",
    method: "get",
    data: {
      data,
    },
  });
};

// 配布
export const sendToMembersService = data => {
  return axios({
    url: "/api/cl/coupon/send-to-members",
    method: "post",
    data: {
      data,
    },
  });
}
export const getTicketHistoryService = data => {
  return axios({
    url: "/api/cl/memberTran/ticket/list",
    method: "get",
    data: {
      data,
    },
  });
}

export const getProductHistroyService = data => {
  return axios({
    url: "/api/cl/memberTran/product/list",
    method: "get",
    data: {
      data,
    },
  });
}

export const adjustNeedMoreViewsService = data => {
  return axios({
    url: `/api/cl/member/adjust-needMoreViews?count=${data.count}&userId=${data.userId}`,
    method: "put",
    data: {},
  });
}

export const updateMemberInfoService = data => {
  return axios({
    url: `/api/cl/member/update-memberInfo/${data.userId}`,
    method: "post",
    data: {
      data: data.memberInfo,
    },
  });
}
